import i18n from "../language/index";
// 全局常量
export default {
  LanguageList: [
    { name: "简体中文", type: "zh_CN" },
    { name: "繁體中文", type: "zh_TW" },
    { name: "English", type: "en_US" },
    { name: "Deutsch", type: "de" }, // 德语
    { name: "Español", type: "es" }, // 西班牙
    { name: "Français", type: "fr" }, // 法语
    { name: "Italiano", type: "it" }, // 意大利
    { name: "עִברִית", type: "he" }, // 希伯来语
    { name: "Русский язык", type: "ru" }, // 俄罗斯
    { name: "Azərbaycan dili", type: "az" }, // 阿塞拜疆
    { name: "Türkçe", type: "tur" }, // 土耳其
    { name: "Việt Nam", type: "vi" }, // 越南
  ],
  cardStrList: [
    {
      title: i18n.t("house.dev"),
      itemList: [
        {
          id: 0,
          name: i18n.t("house.light"),
          smName: i18n.t("house.slight"),
          config: "light",
          iconList: [
            {
              pic: require("@/assets/image/blue_icon/1.png"),
              name: "light",
            },
            {
              pic: require("@/assets/image/grey_icon/1.png"),
              name: "light",
            },
          ],
        },
        {
          id: 1,
          name: i18n.t("house.air"),
          smName: i18n.t("house.sAir"),
          config: "air conditioner",
          iconList: [
            {
              pic: require("@/assets/image/blue_icon/2.png"),
              name: "air conditioner",
            },
            {
              pic: require("@/assets/image/grey_icon/2.png"),
              name: "air conditioner",
            },
          ],
        },
        {
          id: 2,
          name: i18n.t("house.heat"),
          smName: i18n.t("house.sHeat"),
          config: "underfloor heating",
          iconList: [
            {
              pic: require("@/assets/image/blue_icon/3.png"),
              name: "underfloor heating",
            },
            {
              pic: require("@/assets/image/grey_icon/3.png"),
              name: "underfloor heating",
            },
          ],
        },
        {
          id: 3,
          name: i18n.t("house.fresh"),
          smName: i18n.t("house.sFresh"),
          config: "fresh air",
          iconList: [
            {
              pic: require("@/assets/image/blue_icon/4.png"),
              name: "fresh air",
            },
            {
              pic: require("@/assets/image/grey_icon/4.png"),
              name: "fresh air",
            },
          ],
        },
        {
          id: 4,
          name: i18n.t("house.switch"),
          smName: i18n.t("house.sSwitch"),
          config: "switch socket",
          iconList: [
            {
              pic: require("@/assets/image/blue_icon/5.png"),
              name: "switch socket",
            },
            {
              pic: require("@/assets/image/grey_icon/5.png"),
              name: "switch socket",
            },
          ],
        },
        {
          id: 5,
          name: i18n.t("house.curtain"),
          smName: i18n.t("house.sCurtain"),
          config: "curtain",
          iconList: [
            {
              pic: require("@/assets/image/blue_icon/6.png"),
              name: "curtain",
            },
            {
              pic: require("@/assets/image/grey_icon/6.png"),
              name: "curtain",
            },
          ],
        },
        {
          id: 6,
          name: i18n.t("house.water"),
          smName: i18n.t("house.sWater"),
          config: "water heater",
          iconList: [
            {
              pic: require("@/assets/image/blue_icon/7.png"),
              name: "water heater",
            },
            {
              pic: require("@/assets/image/grey_icon/7.png"),
              name: "water heater",
            },
          ],
        },
        {
          id: 7,
          name: i18n.t("house.bgm"),
          smName: i18n.t("house.sBgm"),
          config: "BGM",
          iconList: [
            {
              pic: require("@/assets/image/blue_icon/8.png"),
              name: "BGM",
            },
            {
              pic: require("@/assets/image/grey_icon/8.png"),
              name: "BGM",
            },
          ],
        },
        {
          id: 8,
          name: i18n.t("house.cust"),
          smName: i18n.t("house.sCust"),
          config: "customdevice",
          iconList: [
            {
              pic: require("@/assets/image/blue_icon/9.png"),
              name: "customdevice",
            },
            {
              pic: require("@/assets/image/grey_icon/9.png"),
              name: "customdevice",
            },
          ],
        },
        {
          id: 9,
          name: i18n.t("threeProject.hotWater"),
          smName: i18n.t("threeProject.hotWater"),
          config: "Hot water system",
          iconList: [
            {
              pic: require("@/assets/image/blue_icon/10.png"),
              name: "Hot water system",
            },
            {
              pic: require("@/assets/image/grey_icon/10.png"),
              name: "Hot water system",
            },
          ],
        },
      ],
    },
    {
      title: i18n.t("house.scene"),
      itemList: [
        {
          id: 0,
          name: i18n.t("house.scene1"),
          smName: i18n.t("house.scene1"),
          iconList: [
            {
              pic: require("@/assets/image/blue_icon/scene_blue.png"),
              name: "scene",
            },
            {
              pic: require("@/assets/image/grey_icon/scene_grey.png"),
              name: "scene",
            },
          ],
        },
        {
          id: 1,
          name: i18n.t("house.scene2"),
          smName: i18n.t("house.scene2"),
          iconList: [
            {
              pic: require("@/assets/image/blue_icon/scene_blue.png"),
              name: "scene",
            },
            {
              pic: require("@/assets/image/grey_icon/scene_grey.png"),
              name: "scene",
            },
          ],
        },
        {
          id: 2,
          name: i18n.t("house.scene3"),
          smName: i18n.t("house.scene3"),
          iconList: [
            {
              pic: require("@/assets/image/blue_icon/scene_blue.png"),
              name: "scene",
            },
            {
              pic: require("@/assets/image/grey_icon/scene_grey.png"),
              name: "scene",
            },
          ],
        },
        {
          id: 3,
          name: i18n.t("house.scene4"),
          smName: i18n.t("house.scene4"),
          iconList: [
            {
              pic: require("@/assets/image/blue_icon/scene_blue.png"),
              name: "scene",
            },
            {
              pic: require("@/assets/image/grey_icon/scene_grey.png"),
              name: "scene",
            },
          ],
        },
        {
          id: 4,
          name: i18n.t("house.scene5"),
          smName: i18n.t("house.scene5"),
          iconList: [
            {
              pic: require("@/assets/image/blue_icon/scene_blue.png"),
              name: "scene",
            },
            {
              pic: require("@/assets/image/grey_icon/scene_grey.png"),
              name: "scene",
            },
          ],
        },
        {
          id: 5,
          name: i18n.t("house.scene6"),
          smName: i18n.t("house.scene6"),
          iconList: [
            {
              pic: require("@/assets/image/blue_icon/scene_blue.png"),
              name: "scene",
            },
            {
              pic: require("@/assets/image/grey_icon/scene_grey.png"),
              name: "scene",
            },
          ],
        },
        {
          id: 6,
          name: i18n.t("house.scene7"),
          smName: i18n.t("house.scene7"),
          iconList: [
            {
              pic: require("@/assets/image/blue_icon/scene_blue.png"),
              name: "scene",
            },
            {
              pic: require("@/assets/image/grey_icon/scene_grey.png"),
              name: "scene",
            },
          ],
        },
        {
          id: 7,
          name: i18n.t("house.scene8"),
          smName: i18n.t("house.scene8"),
          iconList: [
            {
              pic: require("@/assets/image/blue_icon/scene_blue.png"),
              name: "scene",
            },
            {
              pic: require("@/assets/image/grey_icon/scene_grey.png"),
              name: "scene",
            },
          ],
        },
      ],
    },
    {
      title: i18n.t("house.vine"),
      itemList: [
        {
          id: 0,
          name: i18n.t("house.temp1"),
          config: "Temperature°：",
          body: "temperature",
          visible: true,
        },
        {
          id: 1,
          name: i18n.t("house.temp2"),
          config: "Humidity:",
          body: "humidity",
          visible: true,
        },
        {
          id: 2,
          name: "PM2.5",
          config: "PM2.5",
          body: "PM2.5",
          visible: true,
        },
        {
          id: 3,
          name: i18n.t("house.temp3"),
          config: "HCHO concentration:",
          body: "HCHO concentration",
          visible: true,
        },
        {
          id: 4,
          name: i18n.t("house.temp4"),
          config: "TVOC Gas:",
          body: "TVOC",
          visible: true,
        },
        {
          id: 5,
          name: "CO2",
          config: "CO2 Gas:",
          body: "CO2",
          visible: true,
        },
      ],
    },
    {
      title: i18n.t("house.single"),
      choose: true,
      itemList: [],
      singleList: [
        { label: i18n.t("common.yes"), value: 1 },
        { label: i18n.t("common.no"), value: 0 },
      ],
    },
    // 三恒
    {
      title: i18n.t("house.threeTitle"),
      itemList: [],
    },
  ],
  noData: require("@/assets/image/noData.png"),
  roomStrList: [
    { name: i18n.t("house.room1"), id: 1 },
    { name: i18n.t("house.room2"), id: 2 },
    { name: i18n.t("house.room3"), id: 3 },
    { name: i18n.t("house.room4"), id: 4 },
    { name: i18n.t("house.room5"), id: 5 },
    { name: i18n.t("house.room6"), id: 6 },
    { name: i18n.t("house.room7"), id: 7 },
    { name: i18n.t("house.room8"), id: 8 },
  ],

  btnFlag: [true, false, false, false, false, false, false, false],

  iconShowList: [
    {
      id: 0,
      iconList: [
        {
          pic: require("@/assets/image/blue_icon/1.png"),
        },
        {
          pic: require("@/assets/image/grey_icon/1.png"),
        },
      ],
    },
    {
      id: 1,
      iconList: [
        {
          pic: require("@/assets/image/blue_icon/2.png"),
        },
        {
          pic: require("@/assets/image/grey_icon/2.png"),
        },
      ],
    },
    {
      id: 2,
      iconList: [
        {
          pic: require("@/assets/image/blue_icon/3.png"),
        },
        {
          pic: require("@/assets/image/grey_icon/3.png"),
        },
      ],
    },
    {
      id: 3,
      iconList: [
        {
          pic: require("@/assets/image/blue_icon/4.png"),
        },
        {
          pic: require("@/assets/image/grey_icon/4.png"),
        },
      ],
    },
    {
      id: 4,
      iconList: [
        {
          pic: require("@/assets/image/blue_icon/5.png"),
        },
        {
          pic: require("@/assets/image/grey_icon/5.png"),
        },
      ],
    },
    {
      id: 5,
      iconList: [
        {
          pic: require("@/assets/image/blue_icon/6.png"),
        },
        {
          pic: require("@/assets/image/grey_icon/6.png"),
        },
      ],
    },
    {
      id: 6,
      iconList: [
        {
          pic: require("@/assets/image/blue_icon/7.png"),
        },
        {
          pic: require("@/assets/image/grey_icon/7.png"),
        },
      ],
    },
    {
      id: 7,
      iconList: [
        {
          pic: require("@/assets/image/blue_icon/8.png"),
        },
        {
          pic: require("@/assets/image/grey_icon/8.png"),
        },
      ],
    },
    {
      id: 8,
      iconList: [
        {
          pic: require("@/assets/image/blue_icon/9.png"),
        },
        {
          pic: require("@/assets/image/grey_icon/9.png"),
        },
      ],
    },

    {
      id: 9,
      iconList: [
        {
          pic: require("@/assets/image/blue_icon/10.png"),
        },
        {
          pic: require("@/assets/image/grey_icon/10.png"),
        },
      ],
    },
    {
      id: 10,
      iconList: [
        {
          pic: require("@/assets/image/blue_icon/scene_blue.png"),
        },
        {
          pic: require("@/assets/image/grey_icon/scene_grey.png"),
        },
      ],
    },
  ],

  seeList: [
    { label: i18n.t("house.see"), id: 1 },
    { label: i18n.t("house.noSee"), id: 0 },
  ],

  iconColorList: [{ label: i18n.t("house.bgIcon"), id: 0 }],
  devNameList: [
    {
      name: "light",
      num: 1,
    },
    {
      name: "air conditioner",
      num: 1,
    },
    {
      name: "underfloor heating",
      num: 1,
    },
    {
      name: "fresh air",
      num: 1,
    },
    {
      name: "switch socket",
      num: 1,
    },
    {
      name: "curtain",
      num: 1,
    },
    {
      name: "water heater",
      num: 1,
    },
    {
      name: "BGM",
      num: 1,
    },
    {
      name: "customdevice",
      num: 1,
    },
    {
      name: "Hot water system",
      num: 1,
    },
  ],

  vineList: [
    {
      id: 0,
      name: i18n.t("house.temp1"),
      config: "Temperature°：",
      body: "temperature",
      visible: true,
    },
    {
      id: 1,
      name: i18n.t("house.temp2"),
      config: "Humidity:",
      body: "humidity",
      visible: true,
    },
    {
      id: 2,
      name: "PM2.5",
      config: "PM2.5",
      body: "PM2.5",
      visible: true,
    },
    {
      id: 3,
      name: i18n.t("house.temp3"),
      config: "HCHO concentration:",
      body: "HCHO concentration",
      visible: true,
    },
    {
      id: 4,
      name: i18n.t("house.temp4"),
      config: "TVOC Gas:",
      body: "TVOC",
      visible: true,
    },
    {
      id: 5,
      name: "CO2",
      config: "CO2 Gas:",
      body: "CO2",
      visible: true,
    },
  ],

  FunctionList: [
    {
      id: 0,
      funName: i18n.t("breadcrumbItem.data"),
      funPic: require("@/assets/image/funPic/devSetting.png"),
      path: "/openList",
    },
    {
      id: 1,
      funName: i18n.t("breadcrumbItem.name"),
      funPic: require("@/assets/image/funPic/name.png"),
      path: "/nameList",
    },

    {
      id: 2,
      funName: i18n.t("breadcrumbItem.house"),
      funPic: require("@/assets/image/funPic/house.png"),
      path: "/floorPlan",
    },
    {
      id: 3,
      funName: i18n.t("breadcrumbItem.alarm"),
      funPic: require("@/assets/image/funPic/alarm.png"),
      path: "/alarmConfig",
    },
    {
      id: 4,
      funName: i18n.t("updateNewSip.moduleName"),
      funPic: require("@/assets/image/funPic/address.png"),
      path: "/projectConfig",
    },
    {
      id: 5,
      funName: i18n.t("audio.title"),
      funPic: require("@/assets/image/funPic/audio.png"),
      path: "/audioPackage",
    },
    {
      id: 6,
      funName: i18n.t("elevator.title"),
      funPic: require("@/assets/image/funPic/elevator.png"),
      path: "/elevatorControl",
    },
  ],

  sendList: [
    { label: i18n.t("alarm.send1"), value: "0", name: "24h_instant" },
    { label: i18n.t("alarm.send2"), value: "1", name: "delay" },
    { label: i18n.t("alarm.send3"), value: "2", name: "transfer" },
    { label: i18n.t("alarm.send4"), value: "3", name: "instant" },
    { label: i18n.t("alarm.send5"), value: "4", name: "cross" },
  ],

  machineList: [
    { label: i18n.t("alarm.mType1"), value: "0", name: "infrared" },
    { label: i18n.t("alarm.mType2"), value: "1", name: "door" },
    { label: i18n.t("alarm.mType3"), value: "2", name: "window" },
    { label: i18n.t("alarm.mType4"), value: "3", name: "gas" },
    { label: i18n.t("alarm.mType5"), value: "4", name: "smoke" },
    { label: i18n.t("alarm.mType6"), value: "5", name: "doorBell" },
    { label: i18n.t("alarm.mType7"), value: "6", name: "manual" },
    { label: i18n.t("alarm.mType8"), value: "7", name: "infrared-DM" },
    { label: i18n.t("alarm.mType9"), value: "8", name: "manual-DM" },
    { label: i18n.t("alarm.mType10"), value: "9", name: "vibration" },
    { label: i18n.t("alarm.mType11"), value: "10", name: "air_pressure" },
    { label: i18n.t("alarm.mType12"), value: "11", name: "other" },
  ],
  nameList: [
    { label: i18n.t("alarm.presence"), value: "0", name: "Presence" },
    { label: i18n.t("alarm.leaving"), value: "1", name: "leaving" },
  ],
  alarmList: [
    { label: i18n.t("alarm.ad"), value: "0", name: "AD" },
    { label: i18n.t("alarm.io"), value: "1", name: "IO" },
  ],
  alarmColumns12: [
    {
      title: i18n.t("alarm.num"),
      align: "center",
      key: "index",
    },
    {
      title: i18n.t("alarm.open") + i18n.t("alarm.close"),
      align: "center",
      slot: "open",
    },
    {
      title: i18n.t("alarm.machine"),
      align: "center",
      slot: "sensor",
    },
    {
      title: i18n.t("alarm.sendType"),
      align: "center",
      slot: "trigger",
    },
    {
      title: i18n.t("alarm.mode"),
      align: "center",
      slot: "mode",
    },
    {
      title: i18n.t("alarm.associated"),
      align: "center",
      slot: "associated",
    },
  ],
  alarmColumns11: [
    {
      title: i18n.t("alarm.num"),
      align: "center",
      key: "index",
    },
    {
      title: i18n.t("alarm.open") + i18n.t("alarm.close"),
      align: "center",
      slot: "open",
    },
    {
      title: i18n.t("alarm.machine"),
      align: "center",
      slot: "sensor",
    },
    {
      title: i18n.t("alarm.sendType"),
      align: "center",
      slot: "trigger",
    },
    {
      title: i18n.t("alarm.associated"),
      align: "center",
      slot: "associated",
    },
  ],
  devTypeList: [
    {
      name: i18n.t("openConfig.IS"),
      value: "IS",
    },
    {
      name: i18n.t("openConfig.GU"),
      value: "GU",
    },
    {
      name: i18n.t("openConfig.OS1"),
      value: "OS1",
    },
    {
      name: i18n.t("openConfig.OS2"),
      value: "OS2",
    },
    {
      name: i18n.t("openConfig.OS3"),
      value: "OS3",
    },
  ],
  nameColumns12: [
    {
      title: i18n.t("openConfig.indexName"),
      align: "center",
      slot: "indexName",
    },
    {
      title: i18n.t("openConfig.devType"),
      align: "center",
      slot: "devType",
    },
    {
      title: i18n.t("openConfig.room"),
      align: "center",
      key: "room",
    },
    {
      title: i18n.t("openConfig.name"),
      align: "center",
      key: "name",
    },
    {
      title: i18n.t("openConfig.pic"),
      slot: "facePicUrl",
      align: "center",
    },
    {
      title: i18n.t("common.action"),
      slot: "action",
      align: "center",
      width: 100,
    },
  ],

  controlList: [
    {
      type: 1, // 主控1 分控0
      name: i18n.t("house.mainControl") + 1,
      on: false,
      visible: false,
      belong: null,
      configList: [
        {
          label: i18n.t("house.temp1"),
          key: "Three constant temperature",
          name: "Temperature°：",
          value: 1,
        },
        {
          label: i18n.t("house.temp2"),
          key: "Three constant humidity",
          name: "Humidity:",
          value: 1,
        },
        {
          label: "PM2.5",
          key: "Three constant PM2.5",
          name: "PM2.5",
          value: 1,
        },
        { label: "CO2", key: "Three constant CO2", name: "CO2 Gas:", value: 1 },
        {
          label: "TVOC",
          key: "Three constant TVOC",
          name: "TVOC Gas:",
          value: 1,
        },
        {
          label: i18n.t("threeProject.cho"),
          key: "Three constant HCHO",
          name: "HCHO concentration:",
          value: 1,
        },
      ],
    },
    {
      type: 0, // 主控1 分控0
      name: i18n.t("house.sedControl") + 1,
      on: false,
      visible: false,
      belong: null,
    },
    {
      type: 0, // 主控1 分控0
      name: i18n.t("house.sedControl") + 2,
      on: false,
      visible: false,
      belong: null,
    },
    {
      type: 0, // 主控1 分控0
      name: i18n.t("house.sedControl") + 3,
      on: false,
      visible: false,
      belong: null,
    },
    {
      type: 0, // 主控1 分控0
      name: i18n.t("house.sedControl") + 4,
      on: false,
      visible: false,
      belong: null,
    },
    {
      type: 0, // 主控1 分控0
      name: i18n.t("house.sedControl") + 5,
      on: false,
      visible: false,
      belong: null,
    },
    {
      type: 0, // 主控1 分控0
      name: i18n.t("house.sedControl") + 6,
      on: false,
      visible: false,
      belong: null,
    },
    {
      type: 0, // 主控1 分控0
      name: i18n.t("house.sedControl") + 7,
      on: false,
      visible: false,
      belong: null,
    },
    {
      type: 0, // 主控1 分控0
      name: i18n.t("house.sedControl") + 8,
      on: false,
      visible: false,
      belong: null,
    },
    {
      type: 0, // 主控1 分控0
      name: i18n.t("house.sedControl") + 9,
      on: false,
      visible: false,
      belong: null,
    },
    {
      type: 0, // 主控1 分控0
      name: i18n.t("house.sedControl") + 10,
      on: false,
      visible: false,
      belong: null,
    },
    {
      type: 0, // 主控1 分控0
      name: i18n.t("house.sedControl") + 11,
      on: false,
      visible: false,
      belong: null,
    },
    {
      type: 0, // 主控1 分控0
      name: i18n.t("house.sedControl") + 12,
      on: false,
      visible: false,
      belong: null,
    },
  ],
};
